import type * as Types from '../../../graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetWorkflowsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetWorkflowsQuery = { workflow: { listWorkflows: Array<{ id: number, name: string, description: string | null, created: string, modified: string | null, creator: { id: number, display: string | null } | null }> } };

export type GetPublishedWorkflowsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetPublishedWorkflowsQuery = { workflow: { publishedWorkflows: Array<{ id: number, name: string, description: string | null, created: string, modified: string | null, creator: { id: number, display: string | null } | null }> } };

export type WorkflowP2TileFragment = { id: number, name: string, description: string | null, created: string, modified: string | null, creator: { id: number, display: string | null } | null };

export type GetVisibleWorkflowEventsQueryVariables = Types.Exact<{
  searchTerm: Types.InputMaybe<Types.Scalars['String']['input']>;
  workflowId: Types.InputMaybe<Types.Scalars['Long']['input']>;
  projectId: Types.InputMaybe<Types.Scalars['Long']['input']>;
  pagination: Types.InputMaybe<Types.InputPaginationInput>;
  sortOrder: Types.InputMaybe<Types.SortOrderEnum>;
}>;


export type GetVisibleWorkflowEventsQuery = { workflow: { listWorkflowEvents: Array<{ workflowEventId: number, alias: string | null, modified: string | null, status: Types.JobStatusEnum | null, lastModifier: { id: number, display: string | null }, owner: { id: number, display: string | null }, project: { id: number, name: string, description: string | null, color: string | null, userGroup: { name: string } | null } | null }> } };

export type LoadWorkflowTemplateConfigQueryVariables = Types.Exact<{
  workflowId: Types.InputMaybe<Types.Scalars['Long']['input']>;
}>;


export type LoadWorkflowTemplateConfigQuery = { workflow: { findWorkflowById: { id: number, config: { activities: Array<{ disabled: boolean | null, identifier: string, name: string, skipped: boolean | null, version: string, metadata: { width: number, position: { x: number, y: number } }, parameters: Array<{ id: string, staged: boolean, values: { __typename: 'BooleanValue', id: string | null, booleanValue: boolean } | { __typename: 'DateValue', id: string | null, dateValue: string } | { __typename: 'FileValue', id: string | null, fileValue: Array<{ id: number, fileName: string | null, deleted: boolean, hidden: boolean } | null> } | { __typename: 'GenomeValue', id: string | null, genomeValue: { id: number, name: string | null, hidden: boolean } } | { __typename: 'NumberValue', id: string | null, numberValue: Array<number> } | { __typename: 'RegionValue', id: string | null, regionValue: { contig: { id: number, name: string | null, accession: string } | null, range: { start: number, stop: number } | null } | null } | { __typename: 'SampleValue', id: string | null, attribute: { id: number, attributeName: string, attributeType: { id: number, name: string } } | null, sampleValue: Array<{ sample: { id: number, name: string | null, hidden: boolean, deleted: boolean | null }, projectFiles: Array<{ id: number, fileName: string | null, hidden: boolean, deleted: boolean } | null> } | null> } | { __typename: 'StringValue', id: string | null, stringValue: Array<string> } | { __typename: 'TrackerValue', id: string | null, trackerValue: { id: number, attributeName: string, attributeType: { id: number, name: string } } } | null }> }>, connectors: Array<{ input: string | null, output: string | null, source: string, target: string }> } } | null } };

export type LoadWorkflowQueryVariables = Types.Exact<{
  workflowId: Types.InputMaybe<Types.Scalars['Long']['input']>;
}>;


export type LoadWorkflowQuery = { workflow: { findWorkflowById: { id: number, name: string, description: string | null, created: string, modified: string | null, config: { outputFolder: { id: number } | null, sampleType: { id: number, name: string } | null, connectors: Array<{ source: string, target: string, input: string | null, output: string | null }>, activities: Array<{ status: Types.WorkflowActivityStatusEnum | null, executor: Types.SupportedExecutorsEnum | null, identifier: string, name: string, version: string, skipped: boolean | null, disabled: boolean | null, outputFolder: { id: number } | null, parameters: Array<{ staged: boolean, id: string, values: { __typename: 'BooleanValue', id: string | null, booleanValue: boolean } | { __typename: 'DateValue', id: string | null, dateValue: string } | { __typename: 'FileValue', id: string | null, fileValue: Array<{ id: number, fileName: string | null, deleted: boolean, hidden: boolean } | null> } | { __typename: 'GenomeValue', id: string | null, genomeValue: { id: number, name: string | null, hidden: boolean } } | { __typename: 'NumberValue', id: string | null, numberValue: Array<number> } | { __typename: 'RegionValue', id: string | null, regionValue: { contig: { id: number, name: string | null, accession: string } | null, range: { start: number, stop: number } | null } | null } | { __typename: 'SampleValue', id: string | null, attribute: { id: number, attributeName: string, attributeType: { id: number, name: string } } | null, sampleValue: Array<{ sample: { id: number, name: string | null, hidden: boolean, deleted: boolean | null }, projectFiles: Array<{ id: number, fileName: string | null, hidden: boolean, deleted: boolean } | null> } | null> } | { __typename: 'StringValue', id: string | null, stringValue: Array<string> } | { __typename: 'TrackerValue', id: string | null, trackerValue: { id: number, attributeName: string, attributeType: { id: number, name: string } } } | null }>, metadata: { width: number, position: { x: number, y: number } } }> }, usergroup: { id: number, name: string, isPrivate: boolean }, creator: { id: number, display: string | null } | null } | null } };

export type LoadWorkflowEventQueryVariables = Types.Exact<{
  workflowEventId: Types.InputMaybe<Types.Scalars['Long']['input']>;
}>;


export type LoadWorkflowEventQuery = { workflow: { findWorkflowEventById: { workflowEventId: number, status: Types.JobStatusEnum | null, alias: string | null, note: string | null, retentionRule: Types.RetentionRuleEnum, project: { id: number } | null, config: { outputFolder: { id: number } | null, sampleType: { id: number, name: string } | null, connectors: Array<{ source: string, target: string, input: string | null, output: string | null }>, activities: Array<{ status: Types.WorkflowActivityStatusEnum | null, executor: Types.SupportedExecutorsEnum | null, identifier: string, name: string, version: string, skipped: boolean | null, disabled: boolean | null, outputFolder: { id: number } | null, parameters: Array<{ staged: boolean, id: string, values: { __typename: 'BooleanValue', id: string | null, booleanValue: boolean } | { __typename: 'DateValue', id: string | null, dateValue: string } | { __typename: 'FileValue', id: string | null, fileValue: Array<{ id: number, fileName: string | null, deleted: boolean, hidden: boolean } | null> } | { __typename: 'GenomeValue', id: string | null, genomeValue: { id: number, name: string | null, hidden: boolean } } | { __typename: 'NumberValue', id: string | null, numberValue: Array<number> } | { __typename: 'RegionValue', id: string | null, regionValue: { contig: { id: number, name: string | null, accession: string } | null, range: { start: number, stop: number } | null } | null } | { __typename: 'SampleValue', id: string | null, attribute: { id: number, attributeName: string, attributeType: { id: number, name: string } } | null, sampleValue: Array<{ sample: { id: number, name: string | null, hidden: boolean, deleted: boolean | null }, projectFiles: Array<{ id: number, fileName: string | null, hidden: boolean, deleted: boolean } | null> } | null> } | { __typename: 'StringValue', id: string | null, stringValue: Array<string> } | { __typename: 'TrackerValue', id: string | null, trackerValue: { id: number, attributeName: string, attributeType: { id: number, name: string } } } | null }>, metadata: { width: number, position: { x: number, y: number } } }> }, workflow: { id: number } | null } | null } };

export type GetActivitiesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetActivitiesQuery = { workflow: { activityCollector: { activities: Array<{ name: string, label: string, default: boolean, description: string, skippable: boolean, path: string, readme: string | null, version: { color: string | null, name: string }, tags: Array<{ name: string, color: string | null }> | null, inputs: Array<{ id: string, label: string, description: string | null, hidden: boolean, optional: boolean, minConnections: number, maxConnections: number | null, compatibleTypes: Array<string> }> | null, outputs: Array<{ id: string, label: string, description: string | null, hidden: boolean, types: Array<string> }> | null, parameters: Array<{ __typename: 'BooleanParam', id: string, label: string, description: string | null, disabled: boolean, group: string | null, optional: boolean, type: Types.WorkflowParameterTypeEnum, booleanDefaultValue: boolean | null } | { __typename: 'DateParam', id: string, label: string, description: string | null, disabled: boolean, group: string | null, optional: boolean, type: Types.WorkflowParameterTypeEnum } | { __typename: 'FileParam', multiSelect: boolean, id: string, label: string, description: string | null, disabled: boolean, group: string | null, optional: boolean, type: Types.WorkflowParameterTypeEnum, fileConstraints: { fileTypes: Array<string> | null, fileSelectionType: Types.FileSelectionTypeEnum | null } | null } | { __typename: 'GenomeParam', id: string, label: string, description: string | null, disabled: boolean, group: string | null, optional: boolean, type: Types.WorkflowParameterTypeEnum, genomeConstraints: { genomeSelectionType: Array<Types.GenomeSelectionTypeEnum> | null } | null } | { __typename: 'NumberParam', multiSelect: boolean, id: string, label: string, description: string | null, disabled: boolean, group: string | null, optional: boolean, type: Types.WorkflowParameterTypeEnum, numberDefaultValue: Array<number> | null, numberConstraints: { maxDecimals: number | null, maxValue: number | null, minValue: number | null, controlledValues: Array<{ label: string | null, value: number, description: string | null }> | null } | null } | { __typename: 'RegionParam', id: string, label: string, description: string | null, disabled: boolean, group: string | null, optional: boolean, type: Types.WorkflowParameterTypeEnum } | { __typename: 'SampleParam', multiSelect: boolean, id: string, label: string, description: string | null, disabled: boolean, group: string | null, optional: boolean, type: Types.WorkflowParameterTypeEnum } | { __typename: 'StringParam', multiSelect: boolean, id: string, label: string, description: string | null, disabled: boolean, group: string | null, optional: boolean, type: Types.WorkflowParameterTypeEnum, stringDefaultValue: Array<string> | null, stringConstraints: { controlledValues: Array<{ label: string | null, value: string, description: string | null }> | null } | null } | { __typename: 'TrackerParam', multiSelect: boolean, tracker: Types.TrackerEnum, id: string, label: string, description: string | null, disabled: boolean, group: string | null, optional: boolean, type: Types.WorkflowParameterTypeEnum }> | null, parameterGroups: Array<{ id: string, label: string, description: string | null, disabled: boolean }> | null, process: { executors: Array<Types.SupportedExecutorsEnum> } }>, errors: Array<{ messages: Array<string> | null, name: string | null, path: string, version: string | null }> } } };

export type ExecuteWorkflowMutationVariables = Types.Exact<{
  workflowEventId: Types.Scalars['Long']['input'];
  targetActivity: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ExecuteWorkflowMutation = { workflow: { executeWorkflow: { workflowEventId: number, alias: string | null, config: { outputFolder: { id: number } | null, activities: Array<{ identifier: string, outputFolder: { id: number } | null }> } } } };

export type StopWorkflowMutationVariables = Types.Exact<{
  workflowEventId: Types.Scalars['Long']['input'];
}>;


export type StopWorkflowMutation = { workflow: { stopWorkflow: boolean } };

export type ResetWorkflowMutationVariables = Types.Exact<{
  workflowEventId: Types.Scalars['Long']['input'];
  nodeIds: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['String']['input']>> | Types.InputMaybe<Types.Scalars['String']['input']>>;
}>;


export type ResetWorkflowMutation = { workflow: { resetWorkflow: { workflowEventId: number, config: { activities: Array<{ identifier: string, status: Types.WorkflowActivityStatusEnum | null }> } } } };

export type GetActivityLogQueryVariables = Types.Exact<{
  activityId: Types.Scalars['String']['input'];
  workflowEventId: Types.Scalars['Long']['input'];
}>;


export type GetActivityLogQuery = { workflow: { activityLog: { errContents: Array<string>, logContents: Array<string> } } };

export type GetWorkflowLogQueryVariables = Types.Exact<{
  workflowEventId: Types.InputMaybe<Types.Scalars['Long']['input']>;
}>;


export type GetWorkflowLogQuery = { workflow: { nextflowLog: string | null } };

export type PublishWorkflowTemplateMutationVariables = Types.Exact<{
  workflow: Types.InputMaybe<Types.InputWorkflowInput>;
}>;


export type PublishWorkflowTemplateMutation = { workflow: { saveWorkflow: { id: number, modified: string | null } } };

export type PublishWorkflowMutationVariables = Types.Exact<{
  workflow: Types.InputWorkflowInput;
  projectId: Types.Scalars['Long']['input'];
}>;


export type PublishWorkflowMutation = { workflow: { publishWorkflow: { id: number, published: boolean, name: string } } };

export type SaveWorkflowEventMutationVariables = Types.Exact<{
  workflow: Types.InputWorkflowEventInput;
}>;


export type SaveWorkflowEventMutation = { workflow: { saveWorkflowEvent: { workflowEventId: number } } };

export type ImportTemplateToWorkflowEventMutationVariables = Types.Exact<{
  workflow: Types.InputWorkflowEventInput;
}>;


export type ImportTemplateToWorkflowEventMutation = { workflow: { importTemplateToWorkflowEvent: { workflowEventId: number } } };

export type LoadWorkflowPreviewDetailsQueryVariables = Types.Exact<{
  workflowId: Types.InputMaybe<Types.Scalars['Long']['input']>;
}>;


export type LoadWorkflowPreviewDetailsQuery = { workflow: { findWorkflowById: { id: number, name: string, description: string | null, created: string, modified: string | null, creator: { firstName: string | null, lastName: string | null, username: string | null } | null, usergroup: { id: number, name: string, isPrivate: boolean } } | null } };

export type LoadWorkflowPreviewPipelineQueryVariables = Types.Exact<{
  workflowId: Types.InputMaybe<Types.Scalars['Long']['input']>;
}>;


export type LoadWorkflowPreviewPipelineQuery = { workflow: { findWorkflowById: { id: number, config: { connectors: Array<{ source: string, target: string, input: string | null, output: string | null }>, activities: Array<{ identifier: string, name: string, version: string, skipped: boolean | null, disabled: boolean | null, metadata: { width: number, position: { x: number, y: number } }, parameters: Array<{ staged: boolean }> }> } } | null } };

export type GetWorkflowEventPreviewQueryVariables = Types.Exact<{
  workflowEventId: Types.Scalars['Long']['input'];
}>;


export type GetWorkflowEventPreviewQuery = { workflow: { findWorkflowEventById: { alias: string | null, workflowEventId: number, config: { connectors: Array<{ source: string, target: string, input: string | null, output: string | null }>, activities: Array<{ identifier: string, name: string, version: string, skipped: boolean | null, disabled: boolean | null, metadata: { width: number, position: { x: number, y: number } }, parameters: Array<{ staged: boolean }> }> } } | null } };

export type GetWorkflowEventDetailsQueryVariables = Types.Exact<{
  workflowEventId: Types.Scalars['Long']['input'];
}>;


export type GetWorkflowEventDetailsQuery = { workflow: { findWorkflowEventById: { alias: string | null, note: string | null, lastExecution: string | null, modified: string | null, status: Types.JobStatusEnum | null, expires: string | null, created: string, lastExecutor: { firstName: string | null, lastName: string | null, username: string | null } | null, lastModifier: { firstName: string | null, lastName: string | null, username: string | null }, owner: { firstName: string | null, lastName: string | null, username: string | null }, project: { id: number, name: string, description: string | null, color: string | null, userGroup: { name: string } | null } | null, workflow: { id: number, name: string } | null } | null } };

export type GetSampleTypesQueryVariables = Types.Exact<{
  userGroupIds: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['Long']['input']>> | Types.InputMaybe<Types.Scalars['Long']['input']>>;
}>;


export type GetSampleTypesQuery = { sample: { sampleTypes: Array<{ id: number, name: string } | null> | null } | null };

export type GetSampleTypeQueryVariables = Types.Exact<{
  sampleTypeId: Types.Scalars['Long']['input'];
  excludeAnalytical: Types.Scalars['Boolean']['input'];
}>;


export type GetSampleTypeQuery = { sample: { sampleType: { id: number, name: string, sampleAttributes: Array<{ __typename: 'Attribute', id: number, attributeName: string, groupName: string | null, automatic: boolean, modifiable: boolean, editable: boolean, multipleValues: boolean, representedColumn: string | null, attributeType: { id: number, name: string }, columnSet: { id: number | null, name: string | null } }> } | null } | null };

export type GetUserGroupsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetUserGroupsQuery = { userGroup: { accessibleUserGroups: Array<{ id: number, name: string, isPrivate: boolean }> } | null };

export type GetProjectFilesFromSampleAttributeQueryVariables = Types.Exact<{
  sampleIds: Array<Types.Scalars['Long']['input']> | Types.Scalars['Long']['input'];
  attributeIds: Types.InputMaybe<Array<Types.Scalars['Long']['input']> | Types.Scalars['Long']['input']>;
}>;


export type GetProjectFilesFromSampleAttributeQuery = { sample: { samples: Array<{ id: number, valuesByAttributeId: Array<{ attribute: { id: number } | null, valueList: Array<{ projectFile: { id: number, deleted: boolean, hidden: boolean } | null } | null> | null }> } | null> | null } | null };

export type GetUserGroupIdOfProjectQueryVariables = Types.Exact<{
  projectId: Types.Scalars['Long']['input'];
}>;


export type GetUserGroupIdOfProjectQuery = { project: { userGroup: { id: number } | null } | null };

export type DefaultValueProps_BooleanValue_Fragment = { __typename: 'BooleanValue', id: string | null };

export type DefaultValueProps_DateValue_Fragment = { __typename: 'DateValue', id: string | null };

export type DefaultValueProps_FileValue_Fragment = { __typename: 'FileValue', id: string | null };

export type DefaultValueProps_GenomeValue_Fragment = { __typename: 'GenomeValue', id: string | null };

export type DefaultValueProps_NumberValue_Fragment = { __typename: 'NumberValue', id: string | null };

export type DefaultValueProps_RegionValue_Fragment = { __typename: 'RegionValue', id: string | null };

export type DefaultValueProps_SampleValue_Fragment = { __typename: 'SampleValue', id: string | null };

export type DefaultValueProps_StringValue_Fragment = { __typename: 'StringValue', id: string | null };

export type DefaultValueProps_TrackerValue_Fragment = { __typename: 'TrackerValue', id: string | null };

export type DefaultValuePropsFragment = DefaultValueProps_BooleanValue_Fragment | DefaultValueProps_DateValue_Fragment | DefaultValueProps_FileValue_Fragment | DefaultValueProps_GenomeValue_Fragment | DefaultValueProps_NumberValue_Fragment | DefaultValueProps_RegionValue_Fragment | DefaultValueProps_SampleValue_Fragment | DefaultValueProps_StringValue_Fragment | DefaultValueProps_TrackerValue_Fragment;

export type StringParameterValueFragment = { __typename: 'StringValue', id: string | null, stringValue: Array<string> };

export type NumberParameterValueFragment = { __typename: 'NumberValue', id: string | null, numberValue: Array<number> };

export type BooleanParameterValueFragment = { __typename: 'BooleanValue', id: string | null, booleanValue: boolean };

export type GenomeParameterValueFragment = { __typename: 'GenomeValue', id: string | null, genomeValue: { id: number, name: string | null, hidden: boolean } };

export type FileParameterValueFragment = { __typename: 'FileValue', id: string | null, fileValue: Array<{ id: number, fileName: string | null, deleted: boolean, hidden: boolean } | null> };

export type SampleParameterValueFragment = { __typename: 'SampleValue', id: string | null, attribute: { id: number, attributeName: string, attributeType: { id: number, name: string } } | null, sampleValue: Array<{ sample: { id: number, name: string | null, hidden: boolean, deleted: boolean | null }, projectFiles: Array<{ id: number, fileName: string | null, hidden: boolean, deleted: boolean } | null> } | null> };

export type RegionParameterValueFragment = { __typename: 'RegionValue', id: string | null, regionValue: { contig: { id: number, name: string | null, accession: string } | null, range: { start: number, stop: number } | null } | null };

export type DateParameterValueFragment = { __typename: 'DateValue', id: string | null, dateValue: string };

export type TrackerParameterValueFragment = { __typename: 'TrackerValue', id: string | null, trackerValue: { id: number, attributeName: string, attributeType: { id: number, name: string } } };

export type WorkflowConnectorFragment = { source: string, target: string, input: string | null, output: string | null };

export type WorkflowActivityFragment = { identifier: string, name: string, version: string, skipped: boolean | null, disabled: boolean | null, metadata: { width: number, position: { x: number, y: number } }, parameters: Array<{ staged: boolean }> };

export type WorkflowParameterFragment = { id: string, staged: boolean, values: { __typename: 'BooleanValue', id: string | null, booleanValue: boolean } | { __typename: 'DateValue', id: string | null, dateValue: string } | { __typename: 'FileValue', id: string | null, fileValue: Array<{ id: number, fileName: string | null, deleted: boolean, hidden: boolean } | null> } | { __typename: 'GenomeValue', id: string | null, genomeValue: { id: number, name: string | null, hidden: boolean } } | { __typename: 'NumberValue', id: string | null, numberValue: Array<number> } | { __typename: 'RegionValue', id: string | null, regionValue: { contig: { id: number, name: string | null, accession: string } | null, range: { start: number, stop: number } | null } | null } | { __typename: 'SampleValue', id: string | null, attribute: { id: number, attributeName: string, attributeType: { id: number, name: string } } | null, sampleValue: Array<{ sample: { id: number, name: string | null, hidden: boolean, deleted: boolean | null }, projectFiles: Array<{ id: number, fileName: string | null, hidden: boolean, deleted: boolean } | null> } | null> } | { __typename: 'StringValue', id: string | null, stringValue: Array<string> } | { __typename: 'TrackerValue', id: string | null, trackerValue: { id: number, attributeName: string, attributeType: { id: number, name: string } } } | null };

export type WorkflowExtendedParameterFragment = { __typename: 'ActivityInstanceExtendedParameter', id: string, staged: boolean, sortOrder: number | null, optional: boolean | null, disabled: boolean, parameterDefinition: { __typename: 'BooleanParam', id: string, description: string | null, disabled: boolean, label: string, type: Types.WorkflowParameterTypeEnum, group: string | null, optional: boolean } | { __typename: 'DateParam', id: string, description: string | null, disabled: boolean, label: string, type: Types.WorkflowParameterTypeEnum, group: string | null, optional: boolean } | { __typename: 'FileParam', multiSelect: boolean, id: string, description: string | null, disabled: boolean, label: string, type: Types.WorkflowParameterTypeEnum, group: string | null, optional: boolean, fileConstraints: { fileTypes: Array<string> | null, fileSelectionType: Types.FileSelectionTypeEnum | null } | null } | { __typename: 'GenomeParam', id: string, description: string | null, disabled: boolean, label: string, type: Types.WorkflowParameterTypeEnum, group: string | null, optional: boolean, genomeConstraints: { genomeSelectionType: Array<Types.GenomeSelectionTypeEnum> | null } | null } | { __typename: 'NumberParam', multiSelect: boolean, id: string, description: string | null, disabled: boolean, label: string, type: Types.WorkflowParameterTypeEnum, group: string | null, optional: boolean, numberConstraints: { id: string | null, maxDecimals: number | null, maxValue: number | null, minValue: number | null, controlledValues: Array<{ label: string | null, value: number, description: string | null }> | null } | null } | { __typename: 'RegionParam', id: string, description: string | null, disabled: boolean, label: string, type: Types.WorkflowParameterTypeEnum, group: string | null, optional: boolean } | { __typename: 'SampleParam', multiSelect: boolean, id: string, description: string | null, disabled: boolean, label: string, type: Types.WorkflowParameterTypeEnum, group: string | null, optional: boolean } | { __typename: 'StringParam', multiSelect: boolean, id: string, description: string | null, disabled: boolean, label: string, type: Types.WorkflowParameterTypeEnum, group: string | null, optional: boolean, stringConstraints: { id: string | null, controlledValues: Array<{ description: string | null, label: string | null, value: string }> | null } | null } | { __typename: 'TrackerParam', multiSelect: boolean, tracker: Types.TrackerEnum, id: string, description: string | null, disabled: boolean, label: string, type: Types.WorkflowParameterTypeEnum, group: string | null, optional: boolean }, values: { __typename: 'BooleanValue', id: string | null, booleanValue: boolean } | { __typename: 'DateValue', id: string | null, dateValue: string } | { __typename: 'FileValue', id: string | null, fileValue: Array<{ id: number, fileName: string | null, deleted: boolean, hidden: boolean } | null> } | { __typename: 'GenomeValue', id: string | null, genomeValue: { id: number, name: string | null, hidden: boolean } } | { __typename: 'NumberValue', id: string | null, numberValue: Array<number> } | { __typename: 'RegionValue', id: string | null, regionValue: { contig: { id: number, name: string | null, accession: string } | null, range: { start: number, stop: number } | null } | null } | { __typename: 'SampleValue', id: string | null, attribute: { id: number, attributeName: string, attributeType: { id: number, name: string } } | null, sampleValue: Array<{ sample: { id: number, name: string | null, hidden: boolean, deleted: boolean | null }, projectFiles: Array<{ id: number, fileName: string | null, hidden: boolean, deleted: boolean } | null> } | null> } | { __typename: 'StringValue', id: string | null, stringValue: Array<string> } | { __typename: 'TrackerValue', id: string | null, trackerValue: { id: number, attributeName: string, attributeType: { id: number, name: string } } } | null };

export type WorkflowConfigActivityFragment = { status: Types.WorkflowActivityStatusEnum | null, executor: Types.SupportedExecutorsEnum | null, identifier: string, name: string, version: string, skipped: boolean | null, disabled: boolean | null, outputFolder: { id: number } | null, parameters: Array<{ staged: boolean, id: string, values: { __typename: 'BooleanValue', id: string | null, booleanValue: boolean } | { __typename: 'DateValue', id: string | null, dateValue: string } | { __typename: 'FileValue', id: string | null, fileValue: Array<{ id: number, fileName: string | null, deleted: boolean, hidden: boolean } | null> } | { __typename: 'GenomeValue', id: string | null, genomeValue: { id: number, name: string | null, hidden: boolean } } | { __typename: 'NumberValue', id: string | null, numberValue: Array<number> } | { __typename: 'RegionValue', id: string | null, regionValue: { contig: { id: number, name: string | null, accession: string } | null, range: { start: number, stop: number } | null } | null } | { __typename: 'SampleValue', id: string | null, attribute: { id: number, attributeName: string, attributeType: { id: number, name: string } } | null, sampleValue: Array<{ sample: { id: number, name: string | null, hidden: boolean, deleted: boolean | null }, projectFiles: Array<{ id: number, fileName: string | null, hidden: boolean, deleted: boolean } | null> } | null> } | { __typename: 'StringValue', id: string | null, stringValue: Array<string> } | { __typename: 'TrackerValue', id: string | null, trackerValue: { id: number, attributeName: string, attributeType: { id: number, name: string } } } | null }>, metadata: { width: number, position: { x: number, y: number } } };

export type WorkflowConfigFragment = { outputFolder: { id: number } | null, sampleType: { id: number, name: string } | null, connectors: Array<{ source: string, target: string, input: string | null, output: string | null }>, activities: Array<{ status: Types.WorkflowActivityStatusEnum | null, executor: Types.SupportedExecutorsEnum | null, identifier: string, name: string, version: string, skipped: boolean | null, disabled: boolean | null, outputFolder: { id: number } | null, parameters: Array<{ staged: boolean, id: string, values: { __typename: 'BooleanValue', id: string | null, booleanValue: boolean } | { __typename: 'DateValue', id: string | null, dateValue: string } | { __typename: 'FileValue', id: string | null, fileValue: Array<{ id: number, fileName: string | null, deleted: boolean, hidden: boolean } | null> } | { __typename: 'GenomeValue', id: string | null, genomeValue: { id: number, name: string | null, hidden: boolean } } | { __typename: 'NumberValue', id: string | null, numberValue: Array<number> } | { __typename: 'RegionValue', id: string | null, regionValue: { contig: { id: number, name: string | null, accession: string } | null, range: { start: number, stop: number } | null } | null } | { __typename: 'SampleValue', id: string | null, attribute: { id: number, attributeName: string, attributeType: { id: number, name: string } } | null, sampleValue: Array<{ sample: { id: number, name: string | null, hidden: boolean, deleted: boolean | null }, projectFiles: Array<{ id: number, fileName: string | null, hidden: boolean, deleted: boolean } | null> } | null> } | { __typename: 'StringValue', id: string | null, stringValue: Array<string> } | { __typename: 'TrackerValue', id: string | null, trackerValue: { id: number, attributeName: string, attributeType: { id: number, name: string } } } | null }>, metadata: { width: number, position: { x: number, y: number } } }> };

export type WorkflowInfoFragment = { id: number, name: string, description: string | null, created: string, modified: string | null, usergroup: { id: number, name: string, isPrivate: boolean }, creator: { id: number, display: string | null } | null };

export type WorkflowP2Fragment = { id: number, name: string, description: string | null, created: string, modified: string | null, config: { outputFolder: { id: number } | null, sampleType: { id: number, name: string } | null, connectors: Array<{ source: string, target: string, input: string | null, output: string | null }>, activities: Array<{ status: Types.WorkflowActivityStatusEnum | null, executor: Types.SupportedExecutorsEnum | null, identifier: string, name: string, version: string, skipped: boolean | null, disabled: boolean | null, outputFolder: { id: number } | null, parameters: Array<{ staged: boolean, id: string, values: { __typename: 'BooleanValue', id: string | null, booleanValue: boolean } | { __typename: 'DateValue', id: string | null, dateValue: string } | { __typename: 'FileValue', id: string | null, fileValue: Array<{ id: number, fileName: string | null, deleted: boolean, hidden: boolean } | null> } | { __typename: 'GenomeValue', id: string | null, genomeValue: { id: number, name: string | null, hidden: boolean } } | { __typename: 'NumberValue', id: string | null, numberValue: Array<number> } | { __typename: 'RegionValue', id: string | null, regionValue: { contig: { id: number, name: string | null, accession: string } | null, range: { start: number, stop: number } | null } | null } | { __typename: 'SampleValue', id: string | null, attribute: { id: number, attributeName: string, attributeType: { id: number, name: string } } | null, sampleValue: Array<{ sample: { id: number, name: string | null, hidden: boolean, deleted: boolean | null }, projectFiles: Array<{ id: number, fileName: string | null, hidden: boolean, deleted: boolean } | null> } | null> } | { __typename: 'StringValue', id: string | null, stringValue: Array<string> } | { __typename: 'TrackerValue', id: string | null, trackerValue: { id: number, attributeName: string, attributeType: { id: number, name: string } } } | null }>, metadata: { width: number, position: { x: number, y: number } } }> }, usergroup: { id: number, name: string, isPrivate: boolean }, creator: { id: number, display: string | null } | null };

export type UserDisplayNameFragment = { firstName: string | null, lastName: string | null, username: string | null };

export type ListingItemUserFragment = { id: number, display: string | null };

export type ProjectForWorkflowFragment = { id: number, name: string, description: string | null, color: string | null, userGroup: { name: string } | null };

export const ListingItemUserFragmentDoc = gql`
    fragment ListingItemUser on User {
  id
  display
}
    `;
export const WorkflowP2TileFragmentDoc = gql`
    fragment WorkflowP2Tile on WorkflowP2 {
  id
  name
  description
  creator {
    ...ListingItemUser
  }
  created
  modified
}
    ${ListingItemUserFragmentDoc}`;
export const DefaultValuePropsFragmentDoc = gql`
    fragment DefaultValueProps on ParameterValue {
  __typename
  id
}
    `;
export const StringParameterValueFragmentDoc = gql`
    fragment StringParameterValue on StringValue {
  ...DefaultValueProps
  ... on StringValue {
    stringValue: value
  }
}
    ${DefaultValuePropsFragmentDoc}`;
export const NumberParameterValueFragmentDoc = gql`
    fragment NumberParameterValue on NumberValue {
  ...DefaultValueProps
  ... on NumberValue {
    numberValue: value
  }
}
    ${DefaultValuePropsFragmentDoc}`;
export const BooleanParameterValueFragmentDoc = gql`
    fragment BooleanParameterValue on BooleanValue {
  ...DefaultValueProps
  ... on BooleanValue {
    booleanValue: value
  }
}
    ${DefaultValuePropsFragmentDoc}`;
export const GenomeParameterValueFragmentDoc = gql`
    fragment GenomeParameterValue on GenomeValue {
  ...DefaultValueProps
  ... on GenomeValue {
    genomeValue: value {
      id
      name
      hidden
    }
  }
}
    ${DefaultValuePropsFragmentDoc}`;
export const FileParameterValueFragmentDoc = gql`
    fragment FileParameterValue on FileValue {
  ...DefaultValueProps
  ... on FileValue {
    fileValue: value {
      id
      fileName
      deleted
      hidden
    }
  }
}
    ${DefaultValuePropsFragmentDoc}`;
export const SampleParameterValueFragmentDoc = gql`
    fragment SampleParameterValue on SampleValue {
  ...DefaultValueProps
  ... on SampleValue {
    attribute {
      id
      attributeName
      attributeType {
        id
        name
      }
    }
    sampleValue: value {
      sample {
        id
        name
        hidden
        deleted
      }
      projectFiles {
        id
        fileName
        hidden
        deleted
      }
    }
  }
}
    ${DefaultValuePropsFragmentDoc}`;
export const RegionParameterValueFragmentDoc = gql`
    fragment RegionParameterValue on RegionValue {
  ...DefaultValueProps
  ... on RegionValue {
    regionValue: value {
      contig {
        id
        name
        accession
      }
      range {
        start
        stop
      }
    }
  }
}
    ${DefaultValuePropsFragmentDoc}`;
export const DateParameterValueFragmentDoc = gql`
    fragment DateParameterValue on DateValue {
  ...DefaultValueProps
  ... on DateValue {
    dateValue: value
  }
}
    ${DefaultValuePropsFragmentDoc}`;
export const TrackerParameterValueFragmentDoc = gql`
    fragment TrackerParameterValue on TrackerValue {
  ...DefaultValueProps
  ... on TrackerValue {
    trackerValue: value {
      id
      attributeName
      attributeType {
        id
        name
      }
    }
  }
}
    ${DefaultValuePropsFragmentDoc}`;
export const WorkflowExtendedParameterFragmentDoc = gql`
    fragment WorkflowExtendedParameter on ActivityInstanceExtendedParameter {
  __typename
  id
  staged
  sortOrder
  optional
  disabled
  parameterDefinition {
    __typename
    id
    description
    disabled
    label
    type
    group
    optional
    ... on StringParam {
      multiSelect
      stringConstraints: constraints {
        id
        controlledValues {
          description
          label
          value
        }
      }
    }
    ... on NumberParam {
      multiSelect
      numberConstraints: constraints {
        id
        maxDecimals
        maxValue
        minValue
        controlledValues {
          label
          value
          description
        }
      }
    }
    ... on SampleParam {
      multiSelect
    }
    ... on FileParam {
      multiSelect
      fileConstraints: constraints {
        fileTypes
        fileSelectionType
      }
    }
    ... on GenomeParam {
      genomeConstraints: constraints {
        genomeSelectionType
      }
    }
    ... on TrackerParam {
      multiSelect
      tracker
    }
  }
  values {
    ...StringParameterValue
    ...NumberParameterValue
    ...BooleanParameterValue
    ...GenomeParameterValue
    ...FileParameterValue
    ...SampleParameterValue
    ...RegionParameterValue
    ...DateParameterValue
    ...TrackerParameterValue
  }
}
    ${StringParameterValueFragmentDoc}
${NumberParameterValueFragmentDoc}
${BooleanParameterValueFragmentDoc}
${GenomeParameterValueFragmentDoc}
${FileParameterValueFragmentDoc}
${SampleParameterValueFragmentDoc}
${RegionParameterValueFragmentDoc}
${DateParameterValueFragmentDoc}
${TrackerParameterValueFragmentDoc}`;
export const WorkflowInfoFragmentDoc = gql`
    fragment WorkflowInfo on WorkflowP2 {
  id
  name
  description
  created
  modified
  usergroup {
    id
    name
    isPrivate
  }
  creator {
    ...ListingItemUser
  }
}
    ${ListingItemUserFragmentDoc}`;
export const WorkflowConnectorFragmentDoc = gql`
    fragment WorkflowConnector on Connector {
  source
  target
  input
  output
}
    `;
export const WorkflowActivityFragmentDoc = gql`
    fragment WorkflowActivity on ActivityInstance {
  identifier
  name
  version
  skipped
  disabled
  metadata {
    position {
      x
      y
    }
    width
  }
  parameters {
    staged
  }
}
    `;
export const WorkflowParameterFragmentDoc = gql`
    fragment WorkflowParameter on ActivityInstanceParameter {
  id
  staged
  values {
    ...StringParameterValue
    ...NumberParameterValue
    ...BooleanParameterValue
    ...GenomeParameterValue
    ...FileParameterValue
    ...SampleParameterValue
    ...RegionParameterValue
    ...DateParameterValue
    ...TrackerParameterValue
  }
}
    ${StringParameterValueFragmentDoc}
${NumberParameterValueFragmentDoc}
${BooleanParameterValueFragmentDoc}
${GenomeParameterValueFragmentDoc}
${FileParameterValueFragmentDoc}
${SampleParameterValueFragmentDoc}
${RegionParameterValueFragmentDoc}
${DateParameterValueFragmentDoc}
${TrackerParameterValueFragmentDoc}`;
export const WorkflowConfigActivityFragmentDoc = gql`
    fragment WorkflowConfigActivity on ActivityInstance {
  ...WorkflowActivity
  status
  outputFolder {
    id
  }
  parameters {
    ...WorkflowParameter
  }
  executor
}
    ${WorkflowActivityFragmentDoc}
${WorkflowParameterFragmentDoc}`;
export const WorkflowConfigFragmentDoc = gql`
    fragment WorkflowConfig on WorkflowConfig {
  outputFolder {
    id
  }
  sampleType {
    id
    name
  }
  connectors {
    ...WorkflowConnector
  }
  activities {
    ...WorkflowConfigActivity
  }
}
    ${WorkflowConnectorFragmentDoc}
${WorkflowConfigActivityFragmentDoc}`;
export const WorkflowP2FragmentDoc = gql`
    fragment WorkflowP2 on WorkflowP2 {
  ...WorkflowInfo
  config {
    ...WorkflowConfig
  }
}
    ${WorkflowInfoFragmentDoc}
${WorkflowConfigFragmentDoc}`;
export const UserDisplayNameFragmentDoc = gql`
    fragment UserDisplayName on User {
  firstName
  lastName
  username
}
    `;
export const ProjectForWorkflowFragmentDoc = gql`
    fragment ProjectForWorkflow on Project {
  id
  name
  description
  color
  userGroup {
    name
  }
}
    `;
export const GetWorkflowsDocument = gql`
    query getWorkflows {
  workflow {
    listWorkflows {
      ...WorkflowP2Tile
    }
  }
}
    ${WorkflowP2TileFragmentDoc}`;

/**
 * __useGetWorkflowsQuery__
 *
 * To run a query within a React component, call `useGetWorkflowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWorkflowsQuery(baseOptions?: Apollo.QueryHookOptions<GetWorkflowsQuery, GetWorkflowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkflowsQuery, GetWorkflowsQueryVariables>(GetWorkflowsDocument, options);
      }
export function useGetWorkflowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkflowsQuery, GetWorkflowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkflowsQuery, GetWorkflowsQueryVariables>(GetWorkflowsDocument, options);
        }
export function useGetWorkflowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkflowsQuery, GetWorkflowsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkflowsQuery, GetWorkflowsQueryVariables>(GetWorkflowsDocument, options);
        }
export type GetWorkflowsQueryHookResult = ReturnType<typeof useGetWorkflowsQuery>;
export type GetWorkflowsLazyQueryHookResult = ReturnType<typeof useGetWorkflowsLazyQuery>;
export type GetWorkflowsSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowsSuspenseQuery>;
export type GetWorkflowsQueryResult = Apollo.QueryResult<GetWorkflowsQuery, GetWorkflowsQueryVariables>;
export const GetPublishedWorkflowsDocument = gql`
    query getPublishedWorkflows {
  workflow {
    publishedWorkflows {
      ...WorkflowP2Tile
    }
  }
}
    ${WorkflowP2TileFragmentDoc}`;

/**
 * __useGetPublishedWorkflowsQuery__
 *
 * To run a query within a React component, call `useGetPublishedWorkflowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublishedWorkflowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublishedWorkflowsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPublishedWorkflowsQuery(baseOptions?: Apollo.QueryHookOptions<GetPublishedWorkflowsQuery, GetPublishedWorkflowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublishedWorkflowsQuery, GetPublishedWorkflowsQueryVariables>(GetPublishedWorkflowsDocument, options);
      }
export function useGetPublishedWorkflowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublishedWorkflowsQuery, GetPublishedWorkflowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublishedWorkflowsQuery, GetPublishedWorkflowsQueryVariables>(GetPublishedWorkflowsDocument, options);
        }
export function useGetPublishedWorkflowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPublishedWorkflowsQuery, GetPublishedWorkflowsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPublishedWorkflowsQuery, GetPublishedWorkflowsQueryVariables>(GetPublishedWorkflowsDocument, options);
        }
export type GetPublishedWorkflowsQueryHookResult = ReturnType<typeof useGetPublishedWorkflowsQuery>;
export type GetPublishedWorkflowsLazyQueryHookResult = ReturnType<typeof useGetPublishedWorkflowsLazyQuery>;
export type GetPublishedWorkflowsSuspenseQueryHookResult = ReturnType<typeof useGetPublishedWorkflowsSuspenseQuery>;
export type GetPublishedWorkflowsQueryResult = Apollo.QueryResult<GetPublishedWorkflowsQuery, GetPublishedWorkflowsQueryVariables>;
export const GetVisibleWorkflowEventsDocument = gql`
    query getVisibleWorkflowEvents($searchTerm: String, $workflowId: Long, $projectId: Long, $pagination: InputPaginationInput, $sortOrder: SortOrderEnum) {
  workflow {
    listWorkflowEvents(
      searchTerm: $searchTerm
      workflowId: $workflowId
      projectId: $projectId
      pagination: $pagination
      sortOrder: $sortOrder
    ) {
      workflowEventId
      alias
      modified
      lastModifier {
        ...ListingItemUser
      }
      status
      owner {
        ...ListingItemUser
      }
      project {
        ...ProjectForWorkflow
      }
    }
  }
}
    ${ListingItemUserFragmentDoc}
${ProjectForWorkflowFragmentDoc}`;

/**
 * __useGetVisibleWorkflowEventsQuery__
 *
 * To run a query within a React component, call `useGetVisibleWorkflowEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVisibleWorkflowEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVisibleWorkflowEventsQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      workflowId: // value for 'workflowId'
 *      projectId: // value for 'projectId'
 *      pagination: // value for 'pagination'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useGetVisibleWorkflowEventsQuery(baseOptions?: Apollo.QueryHookOptions<GetVisibleWorkflowEventsQuery, GetVisibleWorkflowEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVisibleWorkflowEventsQuery, GetVisibleWorkflowEventsQueryVariables>(GetVisibleWorkflowEventsDocument, options);
      }
export function useGetVisibleWorkflowEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVisibleWorkflowEventsQuery, GetVisibleWorkflowEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVisibleWorkflowEventsQuery, GetVisibleWorkflowEventsQueryVariables>(GetVisibleWorkflowEventsDocument, options);
        }
export function useGetVisibleWorkflowEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVisibleWorkflowEventsQuery, GetVisibleWorkflowEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVisibleWorkflowEventsQuery, GetVisibleWorkflowEventsQueryVariables>(GetVisibleWorkflowEventsDocument, options);
        }
export type GetVisibleWorkflowEventsQueryHookResult = ReturnType<typeof useGetVisibleWorkflowEventsQuery>;
export type GetVisibleWorkflowEventsLazyQueryHookResult = ReturnType<typeof useGetVisibleWorkflowEventsLazyQuery>;
export type GetVisibleWorkflowEventsSuspenseQueryHookResult = ReturnType<typeof useGetVisibleWorkflowEventsSuspenseQuery>;
export type GetVisibleWorkflowEventsQueryResult = Apollo.QueryResult<GetVisibleWorkflowEventsQuery, GetVisibleWorkflowEventsQueryVariables>;
export const LoadWorkflowTemplateConfigDocument = gql`
    query loadWorkflowTemplateConfig($workflowId: Long) {
  workflow {
    findWorkflowById(workflowId: $workflowId) {
      id
      config {
        activities {
          disabled
          identifier
          metadata {
            position {
              x
              y
            }
            width
          }
          name
          parameters {
            ...WorkflowParameter
          }
          skipped
          version
        }
        connectors {
          input
          output
          source
          target
        }
      }
    }
  }
}
    ${WorkflowParameterFragmentDoc}`;

/**
 * __useLoadWorkflowTemplateConfigQuery__
 *
 * To run a query within a React component, call `useLoadWorkflowTemplateConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadWorkflowTemplateConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadWorkflowTemplateConfigQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useLoadWorkflowTemplateConfigQuery(baseOptions?: Apollo.QueryHookOptions<LoadWorkflowTemplateConfigQuery, LoadWorkflowTemplateConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoadWorkflowTemplateConfigQuery, LoadWorkflowTemplateConfigQueryVariables>(LoadWorkflowTemplateConfigDocument, options);
      }
export function useLoadWorkflowTemplateConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoadWorkflowTemplateConfigQuery, LoadWorkflowTemplateConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoadWorkflowTemplateConfigQuery, LoadWorkflowTemplateConfigQueryVariables>(LoadWorkflowTemplateConfigDocument, options);
        }
export function useLoadWorkflowTemplateConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LoadWorkflowTemplateConfigQuery, LoadWorkflowTemplateConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LoadWorkflowTemplateConfigQuery, LoadWorkflowTemplateConfigQueryVariables>(LoadWorkflowTemplateConfigDocument, options);
        }
export type LoadWorkflowTemplateConfigQueryHookResult = ReturnType<typeof useLoadWorkflowTemplateConfigQuery>;
export type LoadWorkflowTemplateConfigLazyQueryHookResult = ReturnType<typeof useLoadWorkflowTemplateConfigLazyQuery>;
export type LoadWorkflowTemplateConfigSuspenseQueryHookResult = ReturnType<typeof useLoadWorkflowTemplateConfigSuspenseQuery>;
export type LoadWorkflowTemplateConfigQueryResult = Apollo.QueryResult<LoadWorkflowTemplateConfigQuery, LoadWorkflowTemplateConfigQueryVariables>;
export const LoadWorkflowDocument = gql`
    query loadWorkflow($workflowId: Long) {
  workflow {
    findWorkflowById(workflowId: $workflowId) {
      ...WorkflowP2
    }
  }
}
    ${WorkflowP2FragmentDoc}`;

/**
 * __useLoadWorkflowQuery__
 *
 * To run a query within a React component, call `useLoadWorkflowQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadWorkflowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadWorkflowQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useLoadWorkflowQuery(baseOptions?: Apollo.QueryHookOptions<LoadWorkflowQuery, LoadWorkflowQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoadWorkflowQuery, LoadWorkflowQueryVariables>(LoadWorkflowDocument, options);
      }
export function useLoadWorkflowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoadWorkflowQuery, LoadWorkflowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoadWorkflowQuery, LoadWorkflowQueryVariables>(LoadWorkflowDocument, options);
        }
export function useLoadWorkflowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LoadWorkflowQuery, LoadWorkflowQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LoadWorkflowQuery, LoadWorkflowQueryVariables>(LoadWorkflowDocument, options);
        }
export type LoadWorkflowQueryHookResult = ReturnType<typeof useLoadWorkflowQuery>;
export type LoadWorkflowLazyQueryHookResult = ReturnType<typeof useLoadWorkflowLazyQuery>;
export type LoadWorkflowSuspenseQueryHookResult = ReturnType<typeof useLoadWorkflowSuspenseQuery>;
export type LoadWorkflowQueryResult = Apollo.QueryResult<LoadWorkflowQuery, LoadWorkflowQueryVariables>;
export const LoadWorkflowEventDocument = gql`
    query loadWorkflowEvent($workflowEventId: Long) {
  workflow {
    findWorkflowEventById(workflowEventId: $workflowEventId) {
      workflowEventId
      status
      project {
        id
      }
      alias
      note
      retentionRule
      config {
        ...WorkflowConfig
      }
      workflow {
        id
      }
    }
  }
}
    ${WorkflowConfigFragmentDoc}`;

/**
 * __useLoadWorkflowEventQuery__
 *
 * To run a query within a React component, call `useLoadWorkflowEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadWorkflowEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadWorkflowEventQuery({
 *   variables: {
 *      workflowEventId: // value for 'workflowEventId'
 *   },
 * });
 */
export function useLoadWorkflowEventQuery(baseOptions?: Apollo.QueryHookOptions<LoadWorkflowEventQuery, LoadWorkflowEventQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoadWorkflowEventQuery, LoadWorkflowEventQueryVariables>(LoadWorkflowEventDocument, options);
      }
export function useLoadWorkflowEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoadWorkflowEventQuery, LoadWorkflowEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoadWorkflowEventQuery, LoadWorkflowEventQueryVariables>(LoadWorkflowEventDocument, options);
        }
export function useLoadWorkflowEventSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LoadWorkflowEventQuery, LoadWorkflowEventQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LoadWorkflowEventQuery, LoadWorkflowEventQueryVariables>(LoadWorkflowEventDocument, options);
        }
export type LoadWorkflowEventQueryHookResult = ReturnType<typeof useLoadWorkflowEventQuery>;
export type LoadWorkflowEventLazyQueryHookResult = ReturnType<typeof useLoadWorkflowEventLazyQuery>;
export type LoadWorkflowEventSuspenseQueryHookResult = ReturnType<typeof useLoadWorkflowEventSuspenseQuery>;
export type LoadWorkflowEventQueryResult = Apollo.QueryResult<LoadWorkflowEventQuery, LoadWorkflowEventQueryVariables>;
export const GetActivitiesDocument = gql`
    query getActivities {
  workflow {
    activityCollector {
      activities {
        name
        label
        default
        description
        skippable
        path
        readme
        version {
          color
          name
        }
        tags {
          name
          color
        }
        inputs {
          id
          label
          description
          hidden
          optional
          minConnections
          maxConnections
          compatibleTypes
        }
        outputs {
          id
          label
          description
          hidden
          types
        }
        parameters {
          __typename
          id
          label
          description
          disabled
          group
          optional
          type
          ... on NumberParam {
            multiSelect
            numberDefaultValue: defaultValue
            numberConstraints: constraints {
              controlledValues {
                label
                value
                description
              }
              maxDecimals
              maxValue
              minValue
            }
          }
          ... on StringParam {
            multiSelect
            stringDefaultValue: defaultValue
            stringConstraints: constraints {
              controlledValues {
                label
                value
                description
              }
            }
          }
          ... on SampleParam {
            multiSelect
          }
          ... on BooleanParam {
            booleanDefaultValue: defaultValue
          }
          ... on FileParam {
            multiSelect
            fileConstraints: constraints {
              fileTypes
              fileSelectionType
            }
          }
          ... on GenomeParam {
            genomeConstraints: constraints {
              genomeSelectionType
            }
          }
          ... on TrackerParam {
            multiSelect
            tracker
          }
        }
        parameterGroups {
          id
          label
          description
          disabled
        }
        process {
          executors
        }
      }
      errors {
        messages
        name
        path
        version
      }
    }
  }
}
    `;

/**
 * __useGetActivitiesQuery__
 *
 * To run a query within a React component, call `useGetActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActivitiesQuery(baseOptions?: Apollo.QueryHookOptions<GetActivitiesQuery, GetActivitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActivitiesQuery, GetActivitiesQueryVariables>(GetActivitiesDocument, options);
      }
export function useGetActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActivitiesQuery, GetActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActivitiesQuery, GetActivitiesQueryVariables>(GetActivitiesDocument, options);
        }
export function useGetActivitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActivitiesQuery, GetActivitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActivitiesQuery, GetActivitiesQueryVariables>(GetActivitiesDocument, options);
        }
export type GetActivitiesQueryHookResult = ReturnType<typeof useGetActivitiesQuery>;
export type GetActivitiesLazyQueryHookResult = ReturnType<typeof useGetActivitiesLazyQuery>;
export type GetActivitiesSuspenseQueryHookResult = ReturnType<typeof useGetActivitiesSuspenseQuery>;
export type GetActivitiesQueryResult = Apollo.QueryResult<GetActivitiesQuery, GetActivitiesQueryVariables>;
export const ExecuteWorkflowDocument = gql`
    mutation executeWorkflow($workflowEventId: Long!, $targetActivity: String) {
  workflow {
    executeWorkflow(
      workflowEventId: $workflowEventId
      targetActivity: $targetActivity
    ) {
      workflowEventId
      alias
      config {
        outputFolder {
          id
        }
        activities {
          identifier
          outputFolder {
            id
          }
        }
      }
    }
  }
}
    `;
export type ExecuteWorkflowMutationFn = Apollo.MutationFunction<ExecuteWorkflowMutation, ExecuteWorkflowMutationVariables>;

/**
 * __useExecuteWorkflowMutation__
 *
 * To run a mutation, you first call `useExecuteWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeWorkflowMutation, { data, loading, error }] = useExecuteWorkflowMutation({
 *   variables: {
 *      workflowEventId: // value for 'workflowEventId'
 *      targetActivity: // value for 'targetActivity'
 *   },
 * });
 */
export function useExecuteWorkflowMutation(baseOptions?: Apollo.MutationHookOptions<ExecuteWorkflowMutation, ExecuteWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExecuteWorkflowMutation, ExecuteWorkflowMutationVariables>(ExecuteWorkflowDocument, options);
      }
export type ExecuteWorkflowMutationHookResult = ReturnType<typeof useExecuteWorkflowMutation>;
export type ExecuteWorkflowMutationResult = Apollo.MutationResult<ExecuteWorkflowMutation>;
export type ExecuteWorkflowMutationOptions = Apollo.BaseMutationOptions<ExecuteWorkflowMutation, ExecuteWorkflowMutationVariables>;
export const StopWorkflowDocument = gql`
    mutation stopWorkflow($workflowEventId: Long!) {
  workflow {
    stopWorkflow(workflowEventId: $workflowEventId)
  }
}
    `;
export type StopWorkflowMutationFn = Apollo.MutationFunction<StopWorkflowMutation, StopWorkflowMutationVariables>;

/**
 * __useStopWorkflowMutation__
 *
 * To run a mutation, you first call `useStopWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopWorkflowMutation, { data, loading, error }] = useStopWorkflowMutation({
 *   variables: {
 *      workflowEventId: // value for 'workflowEventId'
 *   },
 * });
 */
export function useStopWorkflowMutation(baseOptions?: Apollo.MutationHookOptions<StopWorkflowMutation, StopWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StopWorkflowMutation, StopWorkflowMutationVariables>(StopWorkflowDocument, options);
      }
export type StopWorkflowMutationHookResult = ReturnType<typeof useStopWorkflowMutation>;
export type StopWorkflowMutationResult = Apollo.MutationResult<StopWorkflowMutation>;
export type StopWorkflowMutationOptions = Apollo.BaseMutationOptions<StopWorkflowMutation, StopWorkflowMutationVariables>;
export const ResetWorkflowDocument = gql`
    mutation resetWorkflow($workflowEventId: Long!, $nodeIds: [String]) {
  workflow {
    resetWorkflow(workflowEventId: $workflowEventId, nodeIds: $nodeIds) {
      workflowEventId
      config {
        activities {
          identifier
          status
        }
      }
    }
  }
}
    `;
export type ResetWorkflowMutationFn = Apollo.MutationFunction<ResetWorkflowMutation, ResetWorkflowMutationVariables>;

/**
 * __useResetWorkflowMutation__
 *
 * To run a mutation, you first call `useResetWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetWorkflowMutation, { data, loading, error }] = useResetWorkflowMutation({
 *   variables: {
 *      workflowEventId: // value for 'workflowEventId'
 *      nodeIds: // value for 'nodeIds'
 *   },
 * });
 */
export function useResetWorkflowMutation(baseOptions?: Apollo.MutationHookOptions<ResetWorkflowMutation, ResetWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetWorkflowMutation, ResetWorkflowMutationVariables>(ResetWorkflowDocument, options);
      }
export type ResetWorkflowMutationHookResult = ReturnType<typeof useResetWorkflowMutation>;
export type ResetWorkflowMutationResult = Apollo.MutationResult<ResetWorkflowMutation>;
export type ResetWorkflowMutationOptions = Apollo.BaseMutationOptions<ResetWorkflowMutation, ResetWorkflowMutationVariables>;
export const GetActivityLogDocument = gql`
    query getActivityLog($activityId: String!, $workflowEventId: Long!) {
  workflow {
    activityLog(activityId: $activityId, workflowEventId: $workflowEventId) {
      errContents
      logContents
    }
  }
}
    `;

/**
 * __useGetActivityLogQuery__
 *
 * To run a query within a React component, call `useGetActivityLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityLogQuery({
 *   variables: {
 *      activityId: // value for 'activityId'
 *      workflowEventId: // value for 'workflowEventId'
 *   },
 * });
 */
export function useGetActivityLogQuery(baseOptions: Apollo.QueryHookOptions<GetActivityLogQuery, GetActivityLogQueryVariables> & ({ variables: GetActivityLogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActivityLogQuery, GetActivityLogQueryVariables>(GetActivityLogDocument, options);
      }
export function useGetActivityLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActivityLogQuery, GetActivityLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActivityLogQuery, GetActivityLogQueryVariables>(GetActivityLogDocument, options);
        }
export function useGetActivityLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActivityLogQuery, GetActivityLogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActivityLogQuery, GetActivityLogQueryVariables>(GetActivityLogDocument, options);
        }
export type GetActivityLogQueryHookResult = ReturnType<typeof useGetActivityLogQuery>;
export type GetActivityLogLazyQueryHookResult = ReturnType<typeof useGetActivityLogLazyQuery>;
export type GetActivityLogSuspenseQueryHookResult = ReturnType<typeof useGetActivityLogSuspenseQuery>;
export type GetActivityLogQueryResult = Apollo.QueryResult<GetActivityLogQuery, GetActivityLogQueryVariables>;
export const GetWorkflowLogDocument = gql`
    query getWorkflowLog($workflowEventId: Long) {
  workflow {
    nextflowLog(workflowEventId: $workflowEventId)
  }
}
    `;

/**
 * __useGetWorkflowLogQuery__
 *
 * To run a query within a React component, call `useGetWorkflowLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowLogQuery({
 *   variables: {
 *      workflowEventId: // value for 'workflowEventId'
 *   },
 * });
 */
export function useGetWorkflowLogQuery(baseOptions?: Apollo.QueryHookOptions<GetWorkflowLogQuery, GetWorkflowLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkflowLogQuery, GetWorkflowLogQueryVariables>(GetWorkflowLogDocument, options);
      }
export function useGetWorkflowLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkflowLogQuery, GetWorkflowLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkflowLogQuery, GetWorkflowLogQueryVariables>(GetWorkflowLogDocument, options);
        }
export function useGetWorkflowLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkflowLogQuery, GetWorkflowLogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkflowLogQuery, GetWorkflowLogQueryVariables>(GetWorkflowLogDocument, options);
        }
export type GetWorkflowLogQueryHookResult = ReturnType<typeof useGetWorkflowLogQuery>;
export type GetWorkflowLogLazyQueryHookResult = ReturnType<typeof useGetWorkflowLogLazyQuery>;
export type GetWorkflowLogSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowLogSuspenseQuery>;
export type GetWorkflowLogQueryResult = Apollo.QueryResult<GetWorkflowLogQuery, GetWorkflowLogQueryVariables>;
export const PublishWorkflowTemplateDocument = gql`
    mutation publishWorkflowTemplate($workflow: InputWorkflowInput) {
  workflow {
    saveWorkflow(workflowInput: $workflow) {
      id
      modified
    }
  }
}
    `;
export type PublishWorkflowTemplateMutationFn = Apollo.MutationFunction<PublishWorkflowTemplateMutation, PublishWorkflowTemplateMutationVariables>;

/**
 * __usePublishWorkflowTemplateMutation__
 *
 * To run a mutation, you first call `usePublishWorkflowTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishWorkflowTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishWorkflowTemplateMutation, { data, loading, error }] = usePublishWorkflowTemplateMutation({
 *   variables: {
 *      workflow: // value for 'workflow'
 *   },
 * });
 */
export function usePublishWorkflowTemplateMutation(baseOptions?: Apollo.MutationHookOptions<PublishWorkflowTemplateMutation, PublishWorkflowTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishWorkflowTemplateMutation, PublishWorkflowTemplateMutationVariables>(PublishWorkflowTemplateDocument, options);
      }
export type PublishWorkflowTemplateMutationHookResult = ReturnType<typeof usePublishWorkflowTemplateMutation>;
export type PublishWorkflowTemplateMutationResult = Apollo.MutationResult<PublishWorkflowTemplateMutation>;
export type PublishWorkflowTemplateMutationOptions = Apollo.BaseMutationOptions<PublishWorkflowTemplateMutation, PublishWorkflowTemplateMutationVariables>;
export const PublishWorkflowDocument = gql`
    mutation publishWorkflow($workflow: InputWorkflowInput!, $projectId: Long!) {
  workflow {
    publishWorkflow(workflowInput: $workflow, projectId: $projectId) {
      id
      published
      name
    }
  }
}
    `;
export type PublishWorkflowMutationFn = Apollo.MutationFunction<PublishWorkflowMutation, PublishWorkflowMutationVariables>;

/**
 * __usePublishWorkflowMutation__
 *
 * To run a mutation, you first call `usePublishWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishWorkflowMutation, { data, loading, error }] = usePublishWorkflowMutation({
 *   variables: {
 *      workflow: // value for 'workflow'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function usePublishWorkflowMutation(baseOptions?: Apollo.MutationHookOptions<PublishWorkflowMutation, PublishWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishWorkflowMutation, PublishWorkflowMutationVariables>(PublishWorkflowDocument, options);
      }
export type PublishWorkflowMutationHookResult = ReturnType<typeof usePublishWorkflowMutation>;
export type PublishWorkflowMutationResult = Apollo.MutationResult<PublishWorkflowMutation>;
export type PublishWorkflowMutationOptions = Apollo.BaseMutationOptions<PublishWorkflowMutation, PublishWorkflowMutationVariables>;
export const SaveWorkflowEventDocument = gql`
    mutation saveWorkflowEvent($workflow: InputWorkflowEventInput!) {
  workflow {
    saveWorkflowEvent(workflowEventInput: $workflow) {
      workflowEventId
    }
  }
}
    `;
export type SaveWorkflowEventMutationFn = Apollo.MutationFunction<SaveWorkflowEventMutation, SaveWorkflowEventMutationVariables>;

/**
 * __useSaveWorkflowEventMutation__
 *
 * To run a mutation, you first call `useSaveWorkflowEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveWorkflowEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveWorkflowEventMutation, { data, loading, error }] = useSaveWorkflowEventMutation({
 *   variables: {
 *      workflow: // value for 'workflow'
 *   },
 * });
 */
export function useSaveWorkflowEventMutation(baseOptions?: Apollo.MutationHookOptions<SaveWorkflowEventMutation, SaveWorkflowEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveWorkflowEventMutation, SaveWorkflowEventMutationVariables>(SaveWorkflowEventDocument, options);
      }
export type SaveWorkflowEventMutationHookResult = ReturnType<typeof useSaveWorkflowEventMutation>;
export type SaveWorkflowEventMutationResult = Apollo.MutationResult<SaveWorkflowEventMutation>;
export type SaveWorkflowEventMutationOptions = Apollo.BaseMutationOptions<SaveWorkflowEventMutation, SaveWorkflowEventMutationVariables>;
export const ImportTemplateToWorkflowEventDocument = gql`
    mutation importTemplateToWorkflowEvent($workflow: InputWorkflowEventInput!) {
  workflow {
    importTemplateToWorkflowEvent(workflowEventInput: $workflow) {
      workflowEventId
    }
  }
}
    `;
export type ImportTemplateToWorkflowEventMutationFn = Apollo.MutationFunction<ImportTemplateToWorkflowEventMutation, ImportTemplateToWorkflowEventMutationVariables>;

/**
 * __useImportTemplateToWorkflowEventMutation__
 *
 * To run a mutation, you first call `useImportTemplateToWorkflowEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportTemplateToWorkflowEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importTemplateToWorkflowEventMutation, { data, loading, error }] = useImportTemplateToWorkflowEventMutation({
 *   variables: {
 *      workflow: // value for 'workflow'
 *   },
 * });
 */
export function useImportTemplateToWorkflowEventMutation(baseOptions?: Apollo.MutationHookOptions<ImportTemplateToWorkflowEventMutation, ImportTemplateToWorkflowEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportTemplateToWorkflowEventMutation, ImportTemplateToWorkflowEventMutationVariables>(ImportTemplateToWorkflowEventDocument, options);
      }
export type ImportTemplateToWorkflowEventMutationHookResult = ReturnType<typeof useImportTemplateToWorkflowEventMutation>;
export type ImportTemplateToWorkflowEventMutationResult = Apollo.MutationResult<ImportTemplateToWorkflowEventMutation>;
export type ImportTemplateToWorkflowEventMutationOptions = Apollo.BaseMutationOptions<ImportTemplateToWorkflowEventMutation, ImportTemplateToWorkflowEventMutationVariables>;
export const LoadWorkflowPreviewDetailsDocument = gql`
    query loadWorkflowPreviewDetails($workflowId: Long) {
  workflow {
    findWorkflowById(workflowId: $workflowId) {
      id
      name
      description
      created
      modified
      creator {
        ...UserDisplayName
      }
      usergroup {
        id
        name
        isPrivate
      }
    }
  }
}
    ${UserDisplayNameFragmentDoc}`;

/**
 * __useLoadWorkflowPreviewDetailsQuery__
 *
 * To run a query within a React component, call `useLoadWorkflowPreviewDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadWorkflowPreviewDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadWorkflowPreviewDetailsQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useLoadWorkflowPreviewDetailsQuery(baseOptions?: Apollo.QueryHookOptions<LoadWorkflowPreviewDetailsQuery, LoadWorkflowPreviewDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoadWorkflowPreviewDetailsQuery, LoadWorkflowPreviewDetailsQueryVariables>(LoadWorkflowPreviewDetailsDocument, options);
      }
export function useLoadWorkflowPreviewDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoadWorkflowPreviewDetailsQuery, LoadWorkflowPreviewDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoadWorkflowPreviewDetailsQuery, LoadWorkflowPreviewDetailsQueryVariables>(LoadWorkflowPreviewDetailsDocument, options);
        }
export function useLoadWorkflowPreviewDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LoadWorkflowPreviewDetailsQuery, LoadWorkflowPreviewDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LoadWorkflowPreviewDetailsQuery, LoadWorkflowPreviewDetailsQueryVariables>(LoadWorkflowPreviewDetailsDocument, options);
        }
export type LoadWorkflowPreviewDetailsQueryHookResult = ReturnType<typeof useLoadWorkflowPreviewDetailsQuery>;
export type LoadWorkflowPreviewDetailsLazyQueryHookResult = ReturnType<typeof useLoadWorkflowPreviewDetailsLazyQuery>;
export type LoadWorkflowPreviewDetailsSuspenseQueryHookResult = ReturnType<typeof useLoadWorkflowPreviewDetailsSuspenseQuery>;
export type LoadWorkflowPreviewDetailsQueryResult = Apollo.QueryResult<LoadWorkflowPreviewDetailsQuery, LoadWorkflowPreviewDetailsQueryVariables>;
export const LoadWorkflowPreviewPipelineDocument = gql`
    query loadWorkflowPreviewPipeline($workflowId: Long) {
  workflow {
    findWorkflowById(workflowId: $workflowId) {
      id
      config {
        connectors {
          ...WorkflowConnector
        }
        activities {
          ...WorkflowActivity
        }
      }
    }
  }
}
    ${WorkflowConnectorFragmentDoc}
${WorkflowActivityFragmentDoc}`;

/**
 * __useLoadWorkflowPreviewPipelineQuery__
 *
 * To run a query within a React component, call `useLoadWorkflowPreviewPipelineQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadWorkflowPreviewPipelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadWorkflowPreviewPipelineQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useLoadWorkflowPreviewPipelineQuery(baseOptions?: Apollo.QueryHookOptions<LoadWorkflowPreviewPipelineQuery, LoadWorkflowPreviewPipelineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoadWorkflowPreviewPipelineQuery, LoadWorkflowPreviewPipelineQueryVariables>(LoadWorkflowPreviewPipelineDocument, options);
      }
export function useLoadWorkflowPreviewPipelineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoadWorkflowPreviewPipelineQuery, LoadWorkflowPreviewPipelineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoadWorkflowPreviewPipelineQuery, LoadWorkflowPreviewPipelineQueryVariables>(LoadWorkflowPreviewPipelineDocument, options);
        }
export function useLoadWorkflowPreviewPipelineSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LoadWorkflowPreviewPipelineQuery, LoadWorkflowPreviewPipelineQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LoadWorkflowPreviewPipelineQuery, LoadWorkflowPreviewPipelineQueryVariables>(LoadWorkflowPreviewPipelineDocument, options);
        }
export type LoadWorkflowPreviewPipelineQueryHookResult = ReturnType<typeof useLoadWorkflowPreviewPipelineQuery>;
export type LoadWorkflowPreviewPipelineLazyQueryHookResult = ReturnType<typeof useLoadWorkflowPreviewPipelineLazyQuery>;
export type LoadWorkflowPreviewPipelineSuspenseQueryHookResult = ReturnType<typeof useLoadWorkflowPreviewPipelineSuspenseQuery>;
export type LoadWorkflowPreviewPipelineQueryResult = Apollo.QueryResult<LoadWorkflowPreviewPipelineQuery, LoadWorkflowPreviewPipelineQueryVariables>;
export const GetWorkflowEventPreviewDocument = gql`
    query getWorkflowEventPreview($workflowEventId: Long!) {
  workflow {
    findWorkflowEventById(workflowEventId: $workflowEventId) {
      alias
      workflowEventId
      config {
        connectors {
          ...WorkflowConnector
        }
        activities {
          ...WorkflowActivity
        }
      }
    }
  }
}
    ${WorkflowConnectorFragmentDoc}
${WorkflowActivityFragmentDoc}`;

/**
 * __useGetWorkflowEventPreviewQuery__
 *
 * To run a query within a React component, call `useGetWorkflowEventPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowEventPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowEventPreviewQuery({
 *   variables: {
 *      workflowEventId: // value for 'workflowEventId'
 *   },
 * });
 */
export function useGetWorkflowEventPreviewQuery(baseOptions: Apollo.QueryHookOptions<GetWorkflowEventPreviewQuery, GetWorkflowEventPreviewQueryVariables> & ({ variables: GetWorkflowEventPreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkflowEventPreviewQuery, GetWorkflowEventPreviewQueryVariables>(GetWorkflowEventPreviewDocument, options);
      }
export function useGetWorkflowEventPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkflowEventPreviewQuery, GetWorkflowEventPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkflowEventPreviewQuery, GetWorkflowEventPreviewQueryVariables>(GetWorkflowEventPreviewDocument, options);
        }
export function useGetWorkflowEventPreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkflowEventPreviewQuery, GetWorkflowEventPreviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkflowEventPreviewQuery, GetWorkflowEventPreviewQueryVariables>(GetWorkflowEventPreviewDocument, options);
        }
export type GetWorkflowEventPreviewQueryHookResult = ReturnType<typeof useGetWorkflowEventPreviewQuery>;
export type GetWorkflowEventPreviewLazyQueryHookResult = ReturnType<typeof useGetWorkflowEventPreviewLazyQuery>;
export type GetWorkflowEventPreviewSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowEventPreviewSuspenseQuery>;
export type GetWorkflowEventPreviewQueryResult = Apollo.QueryResult<GetWorkflowEventPreviewQuery, GetWorkflowEventPreviewQueryVariables>;
export const GetWorkflowEventDetailsDocument = gql`
    query getWorkflowEventDetails($workflowEventId: Long!) {
  workflow {
    findWorkflowEventById(workflowEventId: $workflowEventId) {
      alias
      note
      lastExecutor {
        ...UserDisplayName
      }
      lastExecution
      modified
      lastModifier {
        ...UserDisplayName
      }
      status
      expires
      owner {
        ...UserDisplayName
      }
      created
      project {
        ...ProjectForWorkflow
      }
      workflow {
        id
        name
      }
    }
  }
}
    ${UserDisplayNameFragmentDoc}
${ProjectForWorkflowFragmentDoc}`;

/**
 * __useGetWorkflowEventDetailsQuery__
 *
 * To run a query within a React component, call `useGetWorkflowEventDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowEventDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowEventDetailsQuery({
 *   variables: {
 *      workflowEventId: // value for 'workflowEventId'
 *   },
 * });
 */
export function useGetWorkflowEventDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetWorkflowEventDetailsQuery, GetWorkflowEventDetailsQueryVariables> & ({ variables: GetWorkflowEventDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkflowEventDetailsQuery, GetWorkflowEventDetailsQueryVariables>(GetWorkflowEventDetailsDocument, options);
      }
export function useGetWorkflowEventDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkflowEventDetailsQuery, GetWorkflowEventDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkflowEventDetailsQuery, GetWorkflowEventDetailsQueryVariables>(GetWorkflowEventDetailsDocument, options);
        }
export function useGetWorkflowEventDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkflowEventDetailsQuery, GetWorkflowEventDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkflowEventDetailsQuery, GetWorkflowEventDetailsQueryVariables>(GetWorkflowEventDetailsDocument, options);
        }
export type GetWorkflowEventDetailsQueryHookResult = ReturnType<typeof useGetWorkflowEventDetailsQuery>;
export type GetWorkflowEventDetailsLazyQueryHookResult = ReturnType<typeof useGetWorkflowEventDetailsLazyQuery>;
export type GetWorkflowEventDetailsSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowEventDetailsSuspenseQuery>;
export type GetWorkflowEventDetailsQueryResult = Apollo.QueryResult<GetWorkflowEventDetailsQuery, GetWorkflowEventDetailsQueryVariables>;
export const GetSampleTypesDocument = gql`
    query getSampleTypes($userGroupIds: [Long]) {
  sample {
    sampleTypes(userGroupIds: $userGroupIds) {
      id
      name
    }
  }
}
    `;

/**
 * __useGetSampleTypesQuery__
 *
 * To run a query within a React component, call `useGetSampleTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSampleTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSampleTypesQuery({
 *   variables: {
 *      userGroupIds: // value for 'userGroupIds'
 *   },
 * });
 */
export function useGetSampleTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetSampleTypesQuery, GetSampleTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSampleTypesQuery, GetSampleTypesQueryVariables>(GetSampleTypesDocument, options);
      }
export function useGetSampleTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSampleTypesQuery, GetSampleTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSampleTypesQuery, GetSampleTypesQueryVariables>(GetSampleTypesDocument, options);
        }
export function useGetSampleTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSampleTypesQuery, GetSampleTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSampleTypesQuery, GetSampleTypesQueryVariables>(GetSampleTypesDocument, options);
        }
export type GetSampleTypesQueryHookResult = ReturnType<typeof useGetSampleTypesQuery>;
export type GetSampleTypesLazyQueryHookResult = ReturnType<typeof useGetSampleTypesLazyQuery>;
export type GetSampleTypesSuspenseQueryHookResult = ReturnType<typeof useGetSampleTypesSuspenseQuery>;
export type GetSampleTypesQueryResult = Apollo.QueryResult<GetSampleTypesQuery, GetSampleTypesQueryVariables>;
export const GetSampleTypeDocument = gql`
    query getSampleType($sampleTypeId: Long!, $excludeAnalytical: Boolean!) {
  sample {
    sampleType(sampleTypeId: $sampleTypeId) {
      id
      name
      sampleAttributes(excludeAnalytical: $excludeAnalytical) {
        __typename
        id
        attributeName
        groupName
        attributeType {
          id
          name
        }
        columnSet {
          id
          name
        }
        automatic
        modifiable
        editable
        multipleValues
        representedColumn
      }
    }
  }
}
    `;

/**
 * __useGetSampleTypeQuery__
 *
 * To run a query within a React component, call `useGetSampleTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSampleTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSampleTypeQuery({
 *   variables: {
 *      sampleTypeId: // value for 'sampleTypeId'
 *      excludeAnalytical: // value for 'excludeAnalytical'
 *   },
 * });
 */
export function useGetSampleTypeQuery(baseOptions: Apollo.QueryHookOptions<GetSampleTypeQuery, GetSampleTypeQueryVariables> & ({ variables: GetSampleTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSampleTypeQuery, GetSampleTypeQueryVariables>(GetSampleTypeDocument, options);
      }
export function useGetSampleTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSampleTypeQuery, GetSampleTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSampleTypeQuery, GetSampleTypeQueryVariables>(GetSampleTypeDocument, options);
        }
export function useGetSampleTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSampleTypeQuery, GetSampleTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSampleTypeQuery, GetSampleTypeQueryVariables>(GetSampleTypeDocument, options);
        }
export type GetSampleTypeQueryHookResult = ReturnType<typeof useGetSampleTypeQuery>;
export type GetSampleTypeLazyQueryHookResult = ReturnType<typeof useGetSampleTypeLazyQuery>;
export type GetSampleTypeSuspenseQueryHookResult = ReturnType<typeof useGetSampleTypeSuspenseQuery>;
export type GetSampleTypeQueryResult = Apollo.QueryResult<GetSampleTypeQuery, GetSampleTypeQueryVariables>;
export const GetUserGroupsDocument = gql`
    query getUserGroups {
  userGroup {
    accessibleUserGroups {
      id
      name
      isPrivate
    }
  }
}
    `;

/**
 * __useGetUserGroupsQuery__
 *
 * To run a query within a React component, call `useGetUserGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserGroupsQuery, GetUserGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserGroupsQuery, GetUserGroupsQueryVariables>(GetUserGroupsDocument, options);
      }
export function useGetUserGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserGroupsQuery, GetUserGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserGroupsQuery, GetUserGroupsQueryVariables>(GetUserGroupsDocument, options);
        }
export function useGetUserGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserGroupsQuery, GetUserGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserGroupsQuery, GetUserGroupsQueryVariables>(GetUserGroupsDocument, options);
        }
export type GetUserGroupsQueryHookResult = ReturnType<typeof useGetUserGroupsQuery>;
export type GetUserGroupsLazyQueryHookResult = ReturnType<typeof useGetUserGroupsLazyQuery>;
export type GetUserGroupsSuspenseQueryHookResult = ReturnType<typeof useGetUserGroupsSuspenseQuery>;
export type GetUserGroupsQueryResult = Apollo.QueryResult<GetUserGroupsQuery, GetUserGroupsQueryVariables>;
export const GetProjectFilesFromSampleAttributeDocument = gql`
    query getProjectFilesFromSampleAttribute($sampleIds: [Long!]!, $attributeIds: [Long!]) {
  sample {
    samples(sampleIds: $sampleIds) {
      id
      valuesByAttributeId(attributeIds: $attributeIds) {
        attribute {
          id
        }
        valueList {
          projectFile {
            id
            deleted
            hidden
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetProjectFilesFromSampleAttributeQuery__
 *
 * To run a query within a React component, call `useGetProjectFilesFromSampleAttributeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectFilesFromSampleAttributeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectFilesFromSampleAttributeQuery({
 *   variables: {
 *      sampleIds: // value for 'sampleIds'
 *      attributeIds: // value for 'attributeIds'
 *   },
 * });
 */
export function useGetProjectFilesFromSampleAttributeQuery(baseOptions: Apollo.QueryHookOptions<GetProjectFilesFromSampleAttributeQuery, GetProjectFilesFromSampleAttributeQueryVariables> & ({ variables: GetProjectFilesFromSampleAttributeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectFilesFromSampleAttributeQuery, GetProjectFilesFromSampleAttributeQueryVariables>(GetProjectFilesFromSampleAttributeDocument, options);
      }
export function useGetProjectFilesFromSampleAttributeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectFilesFromSampleAttributeQuery, GetProjectFilesFromSampleAttributeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectFilesFromSampleAttributeQuery, GetProjectFilesFromSampleAttributeQueryVariables>(GetProjectFilesFromSampleAttributeDocument, options);
        }
export function useGetProjectFilesFromSampleAttributeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectFilesFromSampleAttributeQuery, GetProjectFilesFromSampleAttributeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectFilesFromSampleAttributeQuery, GetProjectFilesFromSampleAttributeQueryVariables>(GetProjectFilesFromSampleAttributeDocument, options);
        }
export type GetProjectFilesFromSampleAttributeQueryHookResult = ReturnType<typeof useGetProjectFilesFromSampleAttributeQuery>;
export type GetProjectFilesFromSampleAttributeLazyQueryHookResult = ReturnType<typeof useGetProjectFilesFromSampleAttributeLazyQuery>;
export type GetProjectFilesFromSampleAttributeSuspenseQueryHookResult = ReturnType<typeof useGetProjectFilesFromSampleAttributeSuspenseQuery>;
export type GetProjectFilesFromSampleAttributeQueryResult = Apollo.QueryResult<GetProjectFilesFromSampleAttributeQuery, GetProjectFilesFromSampleAttributeQueryVariables>;
export const GetUserGroupIdOfProjectDocument = gql`
    query getUserGroupIdOfProject($projectId: Long!) {
  project(projectId: $projectId) {
    userGroup {
      id
    }
  }
}
    `;

/**
 * __useGetUserGroupIdOfProjectQuery__
 *
 * To run a query within a React component, call `useGetUserGroupIdOfProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserGroupIdOfProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserGroupIdOfProjectQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetUserGroupIdOfProjectQuery(baseOptions: Apollo.QueryHookOptions<GetUserGroupIdOfProjectQuery, GetUserGroupIdOfProjectQueryVariables> & ({ variables: GetUserGroupIdOfProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserGroupIdOfProjectQuery, GetUserGroupIdOfProjectQueryVariables>(GetUserGroupIdOfProjectDocument, options);
      }
export function useGetUserGroupIdOfProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserGroupIdOfProjectQuery, GetUserGroupIdOfProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserGroupIdOfProjectQuery, GetUserGroupIdOfProjectQueryVariables>(GetUserGroupIdOfProjectDocument, options);
        }
export function useGetUserGroupIdOfProjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserGroupIdOfProjectQuery, GetUserGroupIdOfProjectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserGroupIdOfProjectQuery, GetUserGroupIdOfProjectQueryVariables>(GetUserGroupIdOfProjectDocument, options);
        }
export type GetUserGroupIdOfProjectQueryHookResult = ReturnType<typeof useGetUserGroupIdOfProjectQuery>;
export type GetUserGroupIdOfProjectLazyQueryHookResult = ReturnType<typeof useGetUserGroupIdOfProjectLazyQuery>;
export type GetUserGroupIdOfProjectSuspenseQueryHookResult = ReturnType<typeof useGetUserGroupIdOfProjectSuspenseQuery>;
export type GetUserGroupIdOfProjectQueryResult = Apollo.QueryResult<GetUserGroupIdOfProjectQuery, GetUserGroupIdOfProjectQueryVariables>;
